import Api from './api.service'

export default {
  create (object) {
    return Api().post('event/create', object)
  },
  update (object) {
    return Api().put('event/edit/' + object.id, object.object)
  },
  list (filter) {
    return Api().get('event/get', { params: filter })
  },
  get (id) {
    return Api().get('event/get/' + id)
  }
}